import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  width: 404px;
  height: 204px;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 8px;

  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  gap: 16px;
  margin-bottom: 24px;
`;

export const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconImage = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

export const MessageText = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #333333;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

export const CancelButton = styled.button`
  width: 88px;
  height: 37px;
  background: #f4f7ff;
  color: #2d5bff;
  border: none;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background: #e3eafd;
  }
`;

export const ConfirmButton = styled.button`
  width: 49px;
  height: 37px;
  background: #2d5bff;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;
